import { createSwiper } from "general/js/createSwiper";

document.addEventListener('DOMContentLoaded', function(){

    createSwiper("#swiper-steps");

}, false);
